import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatErr, inr } from "../../lib/api";
import { Loading, PageHeader, StatusPill } from "../../components/Shared";

export default function PlansAdmin() {
  const [plans, setPlans] = useState(null);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({});
  const load = () => api.get("/admin/plans").then((r) => setPlans(r.data));
  useEffect(() => { load().catch(() => setPlans([])); }, []);
  const startEdit = (p) => { setEditing(p.id); setForm({ name: p.name, price: p.price, visits_per_month: p.visits_per_month, benefits: (p.benefits || []).join("\n"), highlighted: p.highlighted, active: p.active }); };
  const save = async () => {
    try {
      await api.patch(`/admin/plans/${editing}`, { ...form, benefits: form.benefits.split("\n").map((s) => s.trim()).filter(Boolean) });
      toast.success("Plan updated — live on the website immediately."); setEditing(null); load();
    } catch (e) { toast.error(formatErr(e)); }
  };
  if (!plans) return <Loading />;
  return (
    <div data-testid="admin-plans">
      <PageHeader title="Subscription Plans" sub="Configure price, visits, benefits and the highlighted plan. Changes go live instantly." />
      <div className="grid gap-5 lg:grid-cols-3">
        {plans.map((p) => (
          <div key={p.id} className="p1-card p-6" data-testid={`admin-plan-${p.id}`}>
            {editing === p.id ? (
              <div className="space-y-3" data-testid={`plan-edit-${p.id}`}>
                <input className="p1-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="plan-edit-name" />
                <div className="grid grid-cols-2 gap-2">
                  <div><label className="p1-label">Price ₹/mo</label><input type="number" className="p1-input" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} data-testid="plan-edit-price" /></div>
                  <div><label className="p1-label">Visits/mo</label><input type="number" className="p1-input" value={form.visits_per_month} onChange={(e) => setForm({ ...form, visits_per_month: e.target.value })} data-testid="plan-edit-visits" /></div>
                </div>
                <textarea className="p1-input" rows={5} value={form.benefits} onChange={(e) => setForm({ ...form, benefits: e.target.value })} placeholder="One benefit per line" data-testid="plan-edit-benefits" />
                <label className="flex items-center gap-2 text-sm"><input type="checkbox" className="h-4 w-4 accent-emerald-800" checked={form.highlighted} onChange={(e) => setForm({ ...form, highlighted: e.target.checked })} data-testid="plan-edit-highlight" /> Highlighted plan</label>
                <label className="flex items-center gap-2 text-sm"><input type="checkbox" className="h-4 w-4 accent-emerald-800" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} data-testid="plan-edit-active" /> Active (visible on website)</label>
                <div className="flex gap-2">
                  <button onClick={save} className="p1-btn-primary !px-5 !py-2" data-testid="plan-save">Save</button>
                  <button onClick={() => setEditing(null)} className="p1-btn-outline !px-5 !py-2" data-testid="plan-cancel">Cancel</button>
                </div>
              </div>
            ) : (
              <>
                <div className="flex items-start justify-between">
                  <h2 className="font-heading text-xl font-bold text-stone-900">{p.name}</h2>
                  <StatusPill status={p.active ? "active" : "closed"} />
                </div>
                <p className="mt-2 font-heading text-3xl font-extrabold text-emerald-900">{inr(p.price)}<span className="text-sm font-medium text-stone-400">/{p.period}</span></p>
                <p className="text-xs text-stone-500">{p.visits_per_month} visits/month {p.highlighted && "· ★ highlighted"}</p>
                <ul className="mt-3 space-y-1 text-xs text-stone-600">{(p.benefits || []).slice(0, 4).map((b) => <li key={b}>• {b}</li>)}</ul>
                <button onClick={() => startEdit(p)} className="p1-btn-outline mt-4 !px-5 !py-2" data-testid={`plan-edit-btn-${p.id}`}>Edit Plan</button>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
